// @ts-nocheck
import {
    createHandlerChainRunner,
    Handler,
    HasOnComplete,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

import { SubmitFormParameter, submitCrmForm } from "@store/Framework/Services/CrmService";

type Parameter = {
    onError?: (error: string) => void;
} & SubmitFormParameter &
    HasOnSuccess<void> &
    HasOnComplete;

type Props = {
    submitFormParameter: SubmitFormParameter;
};

type HandlerType = Handler<Parameter, Props>;

export const InitializeSubmitFormParameter: HandlerType = props => {
    props.submitFormParameter = {
        formType: props.parameter.formType,
        customerInformation: props.parameter.customerInformation,
        formFields: props.parameter.formFields,
        userId: props.parameter.userId,
        shipToCustomerId: props.parameter.shipToCustomerId,
    };
};

export const ComputeUserId: HandlerType = props => {
    if (props.submitFormParameter.userId) {
        return;
    }

    const session = props.getState().context.session;
    props.submitFormParameter.userId = session?.userProfileId ?? null;
};

export const ComputeShipToId: HandlerType = props => {
    if (props.submitFormParameter.shipToCustomerId) {
        return;
    }

    const session = props.getState().context.session;
    props.submitFormParameter.shipToCustomerId =
        (session as any)?.shipToId ?? (session as any)?.shipToCustomerId ?? null;
};

export const SubmitForm: HandlerType = async props => {
    await submitCrmForm(props.submitFormParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    InitializeSubmitFormParameter,
    ComputeUserId,
    ComputeShipToId,
    SubmitForm,
    ExecuteOnSuccessCallback,
];

const submitForm = createHandlerChainRunner(chain, "SubmitForm");
export default submitForm;
